import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-other",
  "use": "dv-other-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-other\"><defs><style>#dv-other .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>资源 4</title><g id=\"dv-other_图层_2\" data-name=\"图层 2\"><g id=\"dv-other_图层_1-2\" data-name=\"图层 1\"><path id=\"dv-other_矩形_280\" data-name=\"矩形 280\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path id=\"dv-other_路径_1262\" data-name=\"路径 1262\" d=\"M19 2.65L5.1 2.61a.76.76 0 0 0-.73.56l-2.87 10v7.49a.76.76 0 0 0 .76.78h19.48a.76.76 0 0 0 .76-.78v-7.54l-2.74-9.9a.76.76 0 0 0-.76-.57zm3.5 11.73h-21v-1.14h21zm-9.73 2.2h2.36V19h-2.36v-2.42zm4.09 0h2.35V19h-2.35v-2.42zm-8.7-8a1 1 0 0 1-.88-.52 1.11 1.11 0 0 1 0-1.06 1 1 0 0 1 .88-.53 1.06 1.06 0 0 1 1 1.1 1 1 0 0 1-1 1.02zm3.84 0a1 1 0 0 1-.88-.52 1.11 1.11 0 0 1 0-1.06 1 1 0 0 1 .88-.52 1.06 1.06 0 0 1 0 2.11zm3.84 0a1 1 0 0 1-.84-.51A1.11 1.11 0 0 1 15 7a1 1 0 0 1 .88-.53 1.06 1.06 0 0 1 0 2.11z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-other.svg
// module id = KtGE
// module chunks = 6